export default [
    {
        path: '/webhooks',
        name: 'webhooks.list',
    },
    {
        path: '/webhooks/:id',
        name: 'webhooks.single'
    },
    {
        path: '/webhooks/events',
        name: 'webhooks.events'
    }
]